import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { hasAccessToRoute } from '../../utils/helpers';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requiredRoute?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRoute }) => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const { modules } = useAppSelector((state) => state.module);
  const location = useLocation();
  // console.log(isAuthenticated,'isAuthenticated');
  

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRoute && !hasAccessToRoute(modules, requiredRoute)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;